import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@material-ui/core';
import AllClientsPage from 'pages/AllClientsPage/AllClientsPage';
import MainContainer from './MainContainer';

const StyledMainSection = styled.div`
  padding: ${({ mobileView }) => (mobileView ? '30px 5px' : '30px 55px')};
  margin-right: ${({ mobileView }) => (mobileView ? '15px' : '')};
`;
function ClientsContainer({ match: { path } }) {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <MainContainer>
      <StyledMainSection mobileView={mobileView}>
        <Switch>
          <Route path={`${path}/all`} exact component={AllClientsPage} />
          <Redirect to={`${path}/all`} />
        </Switch>
      </StyledMainSection>
    </MainContainer>
  );
}
ClientsContainer.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
    isExact: PropTypes.bool,
    params: PropTypes.object,
  }).isRequired,
};
export default ClientsContainer;
